var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh",
    clipPath: "url(#clip0_14978_26236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.2085 5.29427C14.0001 4.08594 12.3418 3.33594 10.5001 3.33594C6.8168 3.33594 3.8418 6.31927 3.8418 10.0026C3.8418 13.6859 6.8168 16.6693 10.5001 16.6693C13.6085 16.6693 16.2001 14.5443 16.9418 11.6693H15.2085C14.5251 13.6109 12.6751 15.0026 10.5001 15.0026C7.7418 15.0026 5.50013 12.7609 5.50013 10.0026C5.50013 7.24427 7.7418 5.0026 10.5001 5.0026C11.8835 5.0026 13.1168 5.5776 14.0168 6.48594L11.3335 9.16927H17.1668V3.33594L15.2085 5.29427Z",
    fill: "#213D69"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14978_26236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.594fab79dbbc54250381ad5458074365.svg";
export { ForwardRef as ReactComponent };